import { useEffect } from "react";

export const Installed = () => {
  const param = new URLSearchParams(document.location.search);

  let source = param.get("source");
  let creative_id = param.get("creative_id");
  let ad_campaign_id = param.get("ad_campaign_id");
  let offer = param.get("offer");
  let creo_id = param.get("creo_id");
  let external_id = param.get("external_id");
  let site_id = param.get("site_id");
  let cost = param.get("cost");
  let sub_id_1 = param.get("sub_id_1");
  let sub_id_2 = param.get("sub_id_2");
  let sub_id_3 = param.get("sub_id_3");
  let id = param.get("id");

  if (!cost) {
    cost = localStorage.getItem("cost");
  }

  if (!sub_id_1) {
    sub_id_1 = localStorage.getItem("sub_id_1");
  }

  if (!sub_id_2) {
    sub_id_2 = localStorage.getItem("sub_id_2");
  }

  if (!sub_id_3) {
    sub_id_3 = localStorage.getItem("sub_id_3");
  }

  if (!creo_id) {
    creo_id = localStorage.getItem("creo_id");
  }

  if (!external_id) {
    external_id = localStorage.getItem("external_id");
  }

  if (!site_id) {
    site_id = localStorage.getItem("site_id");
  }

  if (!source) {
    source = localStorage.getItem("source");
  }

  if (!creative_id) {
    creative_id = localStorage.getItem("creative_id");
  }

  if (!ad_campaign_id) {
    ad_campaign_id = localStorage.getItem("ad_campaign_id");
  }

  if (!offer) {
    offer = localStorage.getItem("offer");
  }

  if (!id) {
    id = localStorage.getItem("id");
  }

  useEffect(() => {
    localStorage.removeItem("isClickedInstall");
  }, []);

  setTimeout(() => {
    if (id === "1092") {
      window.location.href =
        "https://arumo.top/4JGY2twS?a=b" +
        (external_id !== null ? `&external_id=${external_id}` : "") +
        (creo_id !== null ? `&creo_id=${creo_id}` : "") +
        (ad_campaign_id !== null ? `&ad_campaign_id=${ad_campaign_id}` : "") +
        (site_id !== null ? `&site_id=${site_id}` : "");
    } else if (id === "1091") {
      window.location.href =
        "https://arumo.top/Wq3G1mzH?a=b" +
        (creative_id !== null ? `&creative_id=${creative_id}` : "") +
        (ad_campaign_id !== null ? `&ad_campaign_id=${ad_campaign_id}` : "") +
        (source !== null ? `&source=${source}` : "");
    } else if (id === "1096") {
      window.location.href =
        "https://arumo.top/WChY78t3?a=b" +
        (external_id !== null ? `&external_id=${external_id}` : "") +
        (creo_id !== null ? `&creative_id=${creo_id}` : "") +
        (site_id !== null ? `&site_id=${site_id}` : "") +
        (ad_campaign_id !== null ? `&ad_campaign_id=${ad_campaign_id}` : "");
    } else if (id === "1100") {
      window.location.href =
        "https://arumo.top/DVFjchQ9?a=b" +
        (ad_campaign_id !== null ? `&ad_campaign_id=${ad_campaign_id}` : "");
    } else {
      window.location.href =
        "https://arumo.top/4JGY2twS?a=b" +
        (external_id !== null ? `&external_id=${external_id}` : "") +
        (creo_id !== null ? `&creo_id=${creo_id}` : "") +
        (ad_campaign_id !== null ? `&ad_campaign_id=${ad_campaign_id}` : "") +
        (site_id !== null ? `&site_id=${site_id}` : "");
    }
  }, 400);

  setTimeout(() => {
    document.getElementById("openApp").click();
  }, 17400);

  return <div></div>;
};
